import request from '@/utils/request'

//视频帖子列表
export function original(data) {
    return request({
        url: '/api/original/index',
        method: 'post',
        params: data
    })
}
//点赞
export function praise(data) {
    return request({
        url:"/api/praise/save",
        method: 'post',
        params: data
    })
}
//取消点赞
export function praiseDelete(data) {
    return request({
        url:"/api/praise/delete",
        method: 'post',
        params: data
    })
}
//判断是否点赞
export function check(data) {
    return request({
        url:"/api/praise/check",
        method: 'post',
        params: data
    })
}
//帖子收藏
export function collect(data) {
    return request({
        url:"/api/collect/save",
        method: 'post',
        params: data
    })
}
//帖子取消收藏
export function collectDelete(data) {
    return request({
        url:"/api/collect/delete",
        method: 'post',
        params: data
    })
}
//帖子查询是否收藏
export function collectCheck(data) {
    return request({
        url:"/api/collect/check",
        method: 'post',
        params: data
    })
}
//用户是否已经关注
export function followivew(data) {
    return request({
        url:"/api/follow/check",
        method: 'post',
        params: data
    })
}
//关注用户
export function FocusOnTheUser(data) {
    return request({
        url:"/api/follow/save",
        method: 'post',
        params: data
    })
}
//取消关注用户
export function cancelDS(data) {
    return request({
        url:"/api/follow/delete",
        method: 'post',
        params: data
    })
}
//评论列表
export function comment(data) {
    return request({
        url:"/api/comment/index",
        method: 'post',
        params: data
    })
}
//原创视频列表
export function voriginal(data) {
    return request({
        url:"/api/original/follow",
        method: 'post',
        params: data
    })
}
//系统消息
export function notice(data) {
    return request({
        url:"/api/message/notice",
        method: 'post',
        params: data
    })
}
//系统消息查看
export function noticeShow(data) {
    return request({
        url:"/api/message/show",
        method: 'post',
        params: data
    })
}
//系统公告
export function radio(data) {
    return request({
        url:"/api/radio/index",
        method: 'post',
        params: data
    })
}
//公告详情
export function radioDetail(data) {
    return request({
        url:"/api/radio/detail",
        method: 'post',
        params: data
    })
}
//私信
export function privates(data) {
    return request({
        url:"/api/privates/index",
        method: 'post',
        params: data
    })
}
//视频发布
export function videosave(data) {
    return request({
        url:"/upload/api/original/save",
        method: 'post',
        data: data
    })
}
//视频发布
export function details(data) {
    return request({
        url:"api/original/details",
        method: 'post',
        params: data
    })
}



// WEBPACK FOOTER //
// ./src/api/original.js